<template>
  <div>
    <slot name="header"></slot>
    <div v-for="shortlist in sortedShortlists" :key="shortlist.id" class="my-3">
      <Checkbox
        :value="isChecked(shortlist.id)"
        @change="toggleShortlist(shortlist.id)"
      >
        <span
          class="ml-2 hover:cursor-pointer"
          @click="toggleShortlist(shortlist.id)"
        >
          {{ shortlist.name }}
        </span>
      </Checkbox>
    </div>
    <div class="my-4">
      <Modal v-model="isNewShortlistFormVisible" title="New shortlist">
        <ShortlistForm
          v-if="isNewShortlistFormVisible"
          :organization-id="organizationId"
          @create="onShortlistCreate"
          @cancel="closeNewShortlistForm"
        />
      </Modal>
      <TextButton size="sm" type="primary" @click="showNewShortlistForm">
        Add shortlist
      </TextButton>
    </div>
  </div>
</template>

<script>
import Modal from 'components/common/Modal'
import { computed, ref } from '@vue/composition-api'
import Checkbox from 'components/forms/Checkbox'
import ShortlistForm from './ShortlistForm.vue'
import Button from 'components/common/Button'
import TextButton from 'components/common/TextButton'
import { orderBy } from 'lodash'

export default {
  components: {
    Button,
    TextButton,
    Checkbox,
    ShortlistForm,
    Modal,
  },
  props: {
    organizationId: String,
    shortlists: Array,
    startup: Object,
  },
  setup(props, { emit }) {
    const isNewShortlistFormVisible = ref(false)
    const showNewShortlistForm = () => {
      isNewShortlistFormVisible.value = true
    }
    const closeNewShortlistForm = () => {
      isNewShortlistFormVisible.value = false
    }

    const onShortlistCreate = (shortlist) => {
      toggleShortlist(shortlist.id)
      emit('create', shortlist)
      closeNewShortlistForm()
    }
    const selectedSet = ref(new Set())

    const emitChangeSelected = () => {
      emit('change-selected', Array.from(selectedSet.value))
    }

    const init = () => {
      isNewShortlistFormVisible.value = false

      // set initially selected shortlists
      const newSelectedSet = new Set()
      const initiallySelectedShortlists = props.startup.shortlists || []
      initiallySelectedShortlists.forEach((shortlist) => {
        if (
          (shortlist.organization_id && props.organizationId) ||
          (!shortlist.organization_id && !props.organizationId)
        ) {
          newSelectedSet.add(shortlist.id)
        }
      })
      selectedSet.value = newSelectedSet

      emitChangeSelected()
    }

    init()

    const isChecked = (shortlistId) => {
      return selectedSet.value.has(shortlistId)
    }
    const toggleShortlist = (shortlistId) => {
      if (selectedSet.value.has(shortlistId)) {
        selectedSet.value.delete(shortlistId)
        const arr = Array.from(selectedSet.value)
        const newSet = new Set(arr)
        selectedSet.value = newSet
      } else {
        const newSet = new Set(Array.from(selectedSet.value.add(shortlistId)))
        selectedSet.value = newSet
      }
      emitChangeSelected()
    }

    const sortedShortlists = computed(() => {
      return orderBy(
        props.shortlists,
        (s) => {
          return s.name.toLowerCase()
        },
        'asc',
      )
    })

    return {
      isChecked,
      toggleShortlist,

      onShortlistCreate,

      isNewShortlistFormVisible,
      showNewShortlistForm,
      closeNewShortlistForm,

      sortedShortlists,
    }
  },
}
</script>
